import React from 'react'
import { Link } from 'react-router-dom';
import './Dropdown.css'

function DropdownMinistries(props) {
  return (
    <div className='dropdown-menu'>
      <ul>
        <li className='dropdown-li'><Link to='/ministries/outreach' onClick={props} className='dropdown-link'>Outreach</Link></li>
        <li className='dropdown-li'><Link to='/ministries/men' onClick={props} className='dropdown-link'>Men</Link></li>
        <li className='dropdown-li'><Link to='/ministries/women' onClick={props} className='dropdown-link'>Women</Link></li>
        <li className='dropdown-li'><Link to='/ministries/youth-group' onClick={props} className='dropdown-link'>Youth Group</Link></li>
        <li className='dropdown-li'><Link to='/ministries/childrens-ministry' onClick={props} className='dropdown-link'>Children's Ministry</Link></li>
        <li className='dropdown-li'><Link to='/ministries/nursery' onClick={props} className='dropdown-link'>Nursery</Link></li>
    </ul>
  </div>
  )
}
export default DropdownMinistries
